import type {StatusBadgeProps} from './StatusBadge';

export const managementStatus=(value:string|undefined):StatusBadgeProps=>{
  switch((value??'').trim().toLowerCase().replace(/[_-]+/g,' ')){
    case'enquiry':return{text:'At enquiry stage',tone:'neutral'};
    case'mobilising':return{text:'Mobilisation in progress',tone:'information'};
    case'in contract':return{text:'In contract',tone:'success'};
    case'notice given':return{text:'Notice period',tone:'warning'};
    case'lost block':return{text:'Management ended',tone:'neutral'};
    case'archived':return{text:'Archived',tone:'neutral'};
    default:return{text:'Management status unavailable',tone:'unavailable'};
  }
};
